module.exports = __webpack_public_path__ + "media/images/illust/nikol-9981d82ddfba3c9ae2e1305f0583e678.jpg";